import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../../globalUtils';

export const Title = styled.div`
    position: relative;
    cursor: pointer;
    color: #003a70;
    font-size: 48px;
    font-weight: 500;
    margin: 40px 0 40px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 33px;
        font-weight: 400;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 24px;
        margin: 35px 0 27px;
        align-self: center;
    }    
`;

export const PostContainer = styled.div`
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        padding: 20px 0 20px 40px;
    }
    @media only screen and (min-width: ${DESKTOP_WIDTH}px) {
        padding: 20px;
    }  
`;

export const PostWrapper = styled.div`
    background: #fff;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
`;

export const ImageWrapper = styled.div`
    width: 100%;
    position: relative;
    height: 200px;
    overflow: hidden;
`;

export const Image = styled.img`
    max-width: 100%;
`;

export const PostContentWrapper = styled.div`
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    text-align: right;
`;

export const Category = styled.div`
    display: inline-block;
    background: #ff4438;
    line-height: 1.2em;
    color: #fff;
    font-size: 16px;
    padding: 4px 8px;
    border-radius: 8px 8px 0 0;
    position: absolute;
    bottom: 0;
    right: 5px;
`;


export const PostTitle = styled.h3`
    height: 2.6em;
    overflow: hidden;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.3em;
`;

export const Link = styled.a`
    color: #003a70;
    text-decoration: none;
`;
